var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/more_share.bd685318.png","uri@2x": __webpack_public_path__ + "static/media/more_share.a4d722d4.png","uri@3x": __webpack_public_path__ + "static/media/more_share.7c33b37d.png",
    width: 50,
    height: 50
});